/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { SettingsViewType, StepSettingsType } from 'src/constants/settings.contant';
import { BaseAction } from '../../types/global.type';
import * as actions from '../../types/settings.type';

export type SettingsState = {
  role: any,
  isSetting: boolean,
  error?: any,
  step: StepSettingsType,
  mode: SettingsViewType,
};

const initialState: SettingsState = {
  role: null,
  isSetting: false,
  error: null,
  step: StepSettingsType.CONFIG_SETTINGS,
  mode: SettingsViewType.CREATION,
}

export const settingsReducer = (
  state: SettingsState = initialState,
  action: BaseAction
) => {
  switch (action.type) {
    case actions.GET_SETTINGS:
      return {...state, isSetting: true, error: null, isCompleted: false}
    case actions.GET_SETTINGS_SUCCESS:
      return {
        ...state,
        ...action.payload,
        error: null,
        isSetting: false
      }
    case actions.GET_SETTINGS_FAILURE:
      return {...state, error: action.payload, isSetting: false, step: StepSettingsType.ERROR_SETTINGS}
    case actions.SET_SETTINGS:
      return {...state, isSetting: true, error: null, isCompleted: false}
    case actions.SET_SETTINGS_SUCCESS:
      return {
        ...state,
        ...action.payload,
        error: null,
        isSetting: false
      }
    case actions.SET_SETTINGS_FAILURE:
      return {...state, error: action.payload, isSetting: false}
    case actions.SAVE_SETTINGS:
      return {...state, isSetting: true, error: null}
    case actions.SAVE_SETTINGS_SUCCESS:
      return {
        ...state,
        error: null,
        isSetting: false,
        step: StepSettingsType.COMPLETE_SETTINGS
      }
    case actions.SAVE_SETTINGS_FAILURE:
      return {...state, error: action.payload, isSetting: false, step: StepSettingsType.ERROR_SETTINGS}
    case actions.CLEAR_SETTINGS:
      return {...initialState}
    default:
      return state;
  }
};
